import PropTypes from 'prop-types';
import React from 'react';

import TopNavigationDrawerDesktop from 'components/TopNavigationDrawerDesktop';
import TopNavigationHeaderDesktop from 'components/TopNavigationHeaderDesktop';
import TopNavigationSubNavigationDesktop from 'components/TopNavigationSubNavigationDesktop';

const TopNavigationDesktop = ({
  cartItemCount,
  closeTopNavigation,
  isCartOpen,
  isNavigationRerunRenamingExperimentLoading,
  l1ActiveNode,
  l1NavigationOptions,
  openCart,
  setCurrentTopNavigationNode,
  showSearch,
  navigationRerunRenamingExperimentAnalyticsData,
  trackNavigationRerunRenamingExperimentEngagement,
  trackNavigation,
  trackNavigationClick,
}) => {
  if (isNavigationRerunRenamingExperimentLoading) {
    return null;
  }

  return (
    <div className="TopNavigationDesktop" id="top-navigation">
      <TopNavigationHeaderDesktop
        closeTopNavigation={closeTopNavigation}
        isCartOpen={isCartOpen}
        isTopNavigationOpen={!!l1ActiveNode}
        itemCount={cartItemCount}
        l1Options={l1NavigationOptions}
        openCart={openCart}
        setCurrentTopNavigationNode={setCurrentTopNavigationNode}
        showSearch={showSearch}
        trackNavigationRerunRenamingExperimentEngagement={
          trackNavigationRerunRenamingExperimentEngagement
        }
        trackNavigation={trackNavigation}
        trackNavigationClick={trackNavigationClick}
        navigationRerunRenamingExperimentAnalyticsData={
          navigationRerunRenamingExperimentAnalyticsData
        }
      />
      <TopNavigationDrawerDesktop
        l1ActiveNode={l1ActiveNode}
        selectedTopNavigationOption={l1ActiveNode}
      >
        <TopNavigationSubNavigationDesktop
          l1ActiveNode={l1ActiveNode}
          trackNavigation={trackNavigation}
          trackNavigationClick={trackNavigationClick}
        />
      </TopNavigationDrawerDesktop>
    </div>
  );
};

const nodePropType = PropTypes.shape({
  subNavigations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
      id: PropTypes.string,
    })
  ).isRequired,
  featuredCollection: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      mobileImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
      desktopImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
      linkUrl: PropTypes.string.isRequired,
    })
  ),
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  id: PropTypes.string.isRequired,
});

TopNavigationDesktop.propTypes = {
  openCart: PropTypes.func.isRequired,
  l1NavigationOptions: PropTypes.arrayOf(nodePropType).isRequired,
  setCurrentTopNavigationNode: PropTypes.func.isRequired,
  closeTopNavigation: PropTypes.func.isRequired,
  l1ActiveNode: nodePropType,
  isCartOpen: PropTypes.bool.isRequired,
  cartItemCount: PropTypes.number,
  trackNavigationRerunRenamingExperimentEngagement: PropTypes.func,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
  showSearch: PropTypes.bool.isRequired,
  navigationRerunRenamingExperimentAnalyticsData: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
  isNavigationRerunRenamingExperimentLoading: PropTypes.bool,
};

TopNavigationDesktop.defaultProps = {
  l1ActiveNode: null,
  cartItemCount: 0,
  trackNavigationRerunRenamingExperimentEngagement: () => {},
  navigationRerunRenamingExperimentAnalyticsData: null,
  isNavigationRerunRenamingExperimentLoading: false,
};

export default TopNavigationDesktop;
